<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="novoAtendimentoFilaProcModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="fila">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ fila.st_titulo }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input 
                            label="Observações"
                            placeholder="Observações para a fila de preocedimento..."
                            type="textarea"
                            v-model="dados.st_observacoes" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default { 
    data() { 
        return { 
            dados: null, 
            fila: null, 
            atendimento: null, 
            validate: false, 
        };
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    methods: { 
        encaminhar (atendimento, fila) { 
            this.atendimento = atendimento;
            this.fila = fila;

            this.dados = { 
                id_medico: atendimento.id_medico,
                st_nome: atendimento.paciente.st_nome,
                id_paciente: atendimento.id_paciente, 
                id_fila_laudo: fila.id_fila_laudo,
                id_atendimento: atendimento.id_atendimento, 
                st_observacoes: "", 
                fl_ativo: true, 
                fila: fila, 
            };

            $('#novoAtendimentoFilaProcModal').modal('show');
        },

        salvar () { 
            if ( this.dados.paciente ) { 
                this.dados.st_nome = this.dados.paciente.st_nome;
            }

            this.$util.atualizar(this, { 
                service: 'atendimento_outros',
                dados: this.dados, 
                modal: 'novoAtendimentoFilaProcModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>